// extracted by mini-css-extract-plugin
module.exports = {"main":"_1hZ4g","termsList":"_3MSo9","terms":"_2r4Tu","helpText":"_5AT6f","termsHeading":"_2dQq5","orange":"uvao_"};